import { render, staticRenderFns } from "./ConversionSettings.vue?vue&type=template&id=5104b0e0"
import script from "./ConversionSettings.vue?vue&type=script&lang=js"
export * from "./ConversionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports